import { css } from 'styled-components'

export const questionRevealAnimation = css`
  opacity: 0;
  animation: questions-fade-in 1s linear forwards;

  @keyframes questions-fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
